"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles.css");
var _dance = require("../../../assets/movement-buttons/dance.svg");
var _kickLeft = require("../../../assets/movement-buttons/kick-left.svg");
var _kickRight = require("../../../assets/movement-buttons/kick-right.svg");
var _waveLeft = require("../../../assets/movement-buttons/wave-left.svg");
var _waveRight = require("../../../assets/movement-buttons/wave-right.svg");
var _getReady = require("../../../assets/movement-buttons/get-ready.svg");
var _eyes = require("../../../assets/movement-buttons/eyes.svg");
var _showOff = require("../../../assets/movement-buttons/show-off.svg");
var _arrowUp = require("../../../assets/pad-controller/arrow-up.svg");
var _arrowBottom = require("../../../assets/pad-controller/arrow-bottom.svg");
var _arrowLeft = require("../../../assets/pad-controller/arrow-left.svg");
var _arrowRight = require("../../../assets/pad-controller/arrow-right.svg");
var _arrowTurnLeft = require("../../../assets/pad-controller/arrow-turn-left.svg");
var _arrowTurnRight = require("../../../assets/pad-controller/arrow-turn-right.svg");
var _slowWatermark = require("../../../assets/race-track/slow-watermark.svg");
var _fastWatermark = require("../../../assets/race-track/fast-watermark.svg");
var _removable = require("../../../assets/race-track/removable.svg");
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const movementBoxStandardClass = "added-movement-box ";
const movementBoxArrowsClass = "added-movement-box-arrow";
const MOVEMENTS_HASH_MAP = {
  dance: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_dance.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  showOff: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_showOff.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  kickLeft: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_kickLeft.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  kickRight: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_kickRight.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  waveLeft: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_waveLeft.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  waveRight: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_waveRight.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  getReady: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_getReady.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  wiggleEyes: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_eyes.ReactComponent, {}),
    class: movementBoxStandardClass + ""
  },
  stepUp: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowUp.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-up "
  },
  stepDown: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowBottom.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-down "
  },
  sidestepLeft: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowLeft.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-left "
  },
  sidestepRight: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowRight.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-right "
  },
  turnLeft: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowTurnLeft.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-turn-left "
  },
  turnRight: {
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_arrowTurnRight.ReactComponent, {}),
    class: movementBoxStandardClass + movementBoxArrowsClass + " " + movementBoxArrowsClass + "-turn-right "
  }
};
const SPEED_HASH_MAP = {
  slow: /*#__PURE__*/(0, _jsxRuntime.jsx)(_slowWatermark.ReactComponent, {}),
  fast: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fastWatermark.ReactComponent, {})
};
const AddedMovement = _ref => {
  let {
    movement,
    isExecuting,
    speed,
    removable
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "added-movement-container ".concat(removable ? "added-movement-container-removable" : ""),
    children: [removable && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "removable-movement-svg-container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_removable.ReactComponent, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: MOVEMENTS_HASH_MAP[movement].class + (isExecuting ? "currently-executing-movement" : ""),
      children: [MOVEMENTS_HASH_MAP[movement].icon, /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "speed-watermark",
        children: speed && SPEED_HASH_MAP[speed]
      })]
    })]
  });
};
var _default = exports.default = AddedMovement;